import { fmtCurrency } from "../../lib/format";

const pct = (v) => (v == null ? "—" : `${(v * 100).toFixed(1)}%`);

function Delta({ actual, budget }) {
  if (actual == null || !budget) return <span className="text-brand-tertiary">No budget uploaded</span>;
  const d = actual - budget;
  const up = d >= 0;
  return <span className={up ? "text-emerald-700" : "text-rose-600"}>{up ? "▲" : "▼"} {fmtCurrency(Math.abs(d))} {up ? "ahead of" : "behind"} budget</span>;
}

function Kpi({ label, value, sub, tone, testid, accent }) {
  return (
    <div data-testid={testid}
      className={`relative overflow-hidden rounded-xl border p-5 transition-transform duration-200 hover:-translate-y-0.5 ${accent ? "bg-brand-ink border-brand-ink text-brand-page" : "bg-brand-surface border-brand-border"}`}>
      <p className={`text-[10px] uppercase tracking-[0.16em] ${accent ? "text-brand-page/60" : "text-brand-tertiary"}`}>{label}</p>
      <p className={`mt-2 font-serif text-3xl tracking-tight ${tone || (accent ? "text-brand-page" : "text-brand-ink")}`}>{value}</p>
      <p className={`mt-2 text-xs ${accent ? "text-brand-page/70" : "text-brand-muted"}`}>{sub}</p>
    </div>
  );
}

export function ExecKpis({ k, period }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4" data-testid="exec-kpis">
      <Kpi accent label={`Revenue · ${period || "latest"}`} value={fmtCurrency(k.revenue)} sub={<Delta actual={k.revenue} budget={k.revenue_budget} />} testid="exec-kpi-revenue" />
      <Kpi label="Net income" value={fmtCurrency(k.net_income)} tone={k.net_income < 0 ? "text-rose-600" : undefined}
        sub={<Delta actual={k.net_income} budget={k.net_income_budget} />} testid="exec-kpi-net-income" />
      <Kpi label="Occupancy" value={pct(k.occupancy_pct)} sub="Portfolio, latest month" testid="exec-kpi-occupancy" />
      <Kpi label="Member MRR" value={fmtCurrency(k.member_mrr)} sub="Live from Yardi contracts" testid="exec-kpi-mrr" />
      <Kpi label="Open pipeline" value={fmtCurrency(k.pipeline)} sub="CRM deals in progress" testid="exec-kpi-pipeline" />
      <Kpi label="MRR at risk" value={fmtCurrency(k.mrr_at_risk)} tone={k.mrr_at_risk ? "text-rose-600" : undefined}
        sub={`${fmtCurrency(k.notice_mrr)} on notice · ${fmtCurrency(k.delinquent_mrr)} delinquent`} testid="exec-kpi-mrr-at-risk" />
    </div>
  );
}
